import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import momentPropTypes from 'react-moment-proptypes';
import { PropType as PolygotPropType } from 'redux-polyglot';
import ChartCard from 'components/ChartCard';

import Visitors from './visitors';

const VisitorsInView = ({
  p, match, startDate, endDate,
}) => (
  <div>
    <Row>
      <Col span={24}>
        <ChartCard title={p.t('audience.tabs.inview')} showMin>
          <Visitors
            zoneId={match.params.zone_id}
            p={p}
            startDate={startDate}
            endDate={endDate}
          />
        </ChartCard>
      </Col>
    </Row>
  </div>
);

VisitorsInView.propTypes = {
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
  match: PropTypes.object,
  p: PolygotPropType,
};

export default VisitorsInView;
